export const colors = {
  bgPage1: "#3B4664",
  while: "#fff",
  bgRangePage1: "#252C46",
  colorRangePage1: "#CB422E",
  bgInputPage1: "#181F32",
  bgProcessesPage1: "#252D44",
  colorNumbersPage1: "#464C58",
  bgBtnsPage1: "#647299",

  bgPage2: "#E6E6E6",
  colorRangePage2: "#C75400",
  bgRangePage2: "#D5CCCC",
  colorTxtPage2: "#333329",
  bgProcessesPage2: "#D3CDCD",
  bgBtnsPage2: "#388187",

  bgPage3: "#17062A",
  colorTxtPage3: "#FDDD3E",
  colorRangePage3: "#00DBCE",
  bgRangePage3: "#1E0837",
  bgInputPage3: "#1E0837",
  bgBtnsPage3: "#331B4D",
  bgBtns: "#56077C",
};
